import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { NumberBadge } from '@/components/ui/Badge/NumberBadge';
import { propChildren, propNumber, propStr } from '@/helpers/custom-prop-types';
/**
 * TODO: TS化 & tailwind化
 */
const NavigationListItem = (props) => {
    const { className, count, svg, text } = props;
    return (_jsxs("div", Object.assign({ className: clsx('navigation-box', 'relative', className) }, { children: [_jsx("div", Object.assign({ className: 'navigation-image-box rect' }, { children: svg })), _jsx("div", Object.assign({ className: 'navigation-text-box wbr' }, { children: text })), count > 0 && (_jsx(NumberBadge, { className: 'navigation-count-box absolute', number: count }))] })));
};
NavigationListItem.propTypes = {
    className: propStr().isRequired,
    count: propNumber().isRequired,
    svg: propChildren().isRequired,
    text: propChildren().isRequired,
};
export default NavigationListItem;
